module.exports = __webpack_public_path__ + "img/coo_loyalty.029dabbb.png";